export class Community {
  id: string;
  name: string;
  avatar: string;
  location: any;
  isActive = true;
  userCount: number;
  operatorId: string;
  subAccountCode: string;
  reference: string;
  createdAt: number;
  updatedAt: number;

  constructor() {
    this.createdAt = this.updatedAt = Date.now();
  }
}

export class Country {
  code: string;
  continent: string;
  currencyId: string;
  flag: string;
  name: string;
  phoneCode: string;

  constructor() {
    this.code = "NG";
    this.continent = "Africa";
    this.currencyId = "NGN";
    this.flag = "🇳🇬";
    this.name = "Nigeria";
    this.phoneCode = "234";
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/community/community.ts